import styled from '@emotion/styled';
import { SectionText } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  margin-bottom: 50px;
`;

export const TopWrapper = styled.div<{ marginTop: number }>`
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${(props) => `${props.marginTop}px`};

  ${mediaQuery('tablet')} {
    max-width: 700px;
  }

  ${mediaQuery('small')} {
    margin-left: 24px;
    margin-right: 24px;
    max-width: none;
  }
`;

export const StepLineWrapper = styled.div`
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
  background-color: ${(props) => props.theme.color.light.default};
`;

export const AuthWrapper = styled.div`
  margin-top: 40px;
`;

export const Title = styled.div`
  color: ${(props) => props.theme.color.light.default};
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 40px;
`;

export const Content = styled.div`
  max-width: 600px;
  margin: 30px auto 0 auto;

  ${mediaQuery('tablet')} {
    max-width: 600px;
    min-height: auto;
  }

  ${mediaQuery('small')} {
    margin-left: 24px;
    margin-right: 24px;
    max-width: none;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  gap: 12px;
`;

export const ImageWrapper = styled.img<{ position: 'right' | 'left' }>`
  position: absolute;
  bottom: -50px;
  width: 200px;

  ${(props) => props.position === 'right' && 'right: 0; transform: translateX(100%)'};
  ${(props) => props.position === 'left' && 'left: 0; transform: translateX(-100%)'};

  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const SuccessStepLineWrapper = styled.div`
  padding: 32px 48px;
  border: ${(props) => `1px solid ${props.theme.color.light.shadeLighter}`};
  border-radius: 8px;
  margin-top: 40px;
  margin-bottom: 20px;
  ${mediaQuery('tablet')} {
    width: 90%;
  }
`;

export const ModalText = styled(SectionText)`
  margin: 20px 0;
  text-align: left;
  ul {
    list-style: disc !important;
  }
`;

export const ModalSubText = styled(SectionText)`
  margin-bottom: 25px;
  font-weight: 600;
  color: ${(props) => props.theme.color.blue.default};
`;

export const PartnerInfoBoxWrapper = styled.div`
  position: absolute;
  right: 10px;
  width: 300px;
  top: 425px;
`;
